import Vue from 'vue';
import Router from 'vue-router';
import OurPublicProfiles from '@/views/AgencyDashboard/OurPublicProfiles/OurPublicProfiles';
import OurPublicProfilesDetail from '@/views/AgencyDashboard/OurPublicProfiles/OurPublicProfilesDetail';
import MatchmakingRequests from '@/views/AgencyDashboard/MatchmakingRequests';
import MatchmakingRequestsDetail from '@/views/AgencyDashboard/MatchmakingRequestsDetail';
import Leads from '@/views/AgencyDashboard/Leads';
import LeadDetail from '@/views/AgencyDashboard/LeadDetail';
import FindPartners from '@/views/AgencyDashboard/FindPartners';
import SendInvitation from '@/views/AgencyDashboard/SendInvitation';
import OurDirectory from '@/views/AgencyDashboard/OurDirectory';
import Settings from '@/views/AgencyDashboard/Settings';
import SettingsForm from '@/components/AgencyDashboard/SettingsForm';
import SettingsCategories from '@/components/AgencyDashboard/SettingsCategories';
import ManagePartners from '@/views/AgencyDashboard/ManagePartners';
import ManagePartnersDetail from '@/views/AgencyDashboard/ManagePartnersDetail';
import UserAccount from '@/views/Dashboard/UserAccount';
import UserAccountNameForm from '@/components/Dashboard/UserAccountNameForm';
import UserAccountPasswordForm from '@/components/Dashboard/UserAccountPasswordForm';
import UserAccountApiForm from '@/components/Dashboard/UserAccountApiForm';
import ManagePartnersInvitation from '@/views/AgencyDashboard/ManagePartnersInvitation';
import AddPartnerFromInvite from '@/components/AgencyDashboard/AddPartnerFromInvite';
import AddPartnerFromGetListed from '@/components/AgencyDashboard/AddPartnerFromGetListed';
import UserAccountTeamList from '@/components/Dashboard/UserAccountTeamList';
import UserAccountTeamInvite from '@/components/Dashboard/UserAccountTeamInvite';

Vue.use(Router);

export const agencyDashboard = [
  {
    path: '/agency',
    name: 'Index',
    component: OurPublicProfiles,
  },
  {
    path: '/agency/our-directory/matchmaking',
    name: 'matchmakingrequests',
    component: MatchmakingRequests,
  },
  {
    path: '/agency/our-directory/matchmaking/:id',
    name: 'matchmakingrequestsdetail',
    component: MatchmakingRequestsDetail,
  },
  {
    path: '/agency/our-public-profiles',
    name: 'OurPublicProfiles',
    component: OurPublicProfiles,
  },
  {
    path: '/agency/our-public-profiles/leads/:id',
    name: 'Leads',
    meta: { OurPublicProfilesNav: true },
    component: Leads,
  },
  {
    path: '/agency/our-public-profiles/leads/:id/lead/:leadId',
    name: 'LeadDetail',
    meta: { OurPublicProfilesNav: true },
    component: LeadDetail,
  },
  {
    path: '/agency/our-public-profiles/:id',
    name: 'OurPublicProfilesDetail',
    component: OurPublicProfilesDetail,
    meta: { OurPublicProfilesNav: true },
  },
  {
    path: '/agency/find-partners',
    name: 'FindPartners',
    component: FindPartners,
  },
  {
    path: '/add_partner/:inviteId/:vendorId/:vendorName',
    name: 'AddPartnerFromInvite',
    component: AddPartnerFromInvite,
  },
  {
    path: '/agency/get-listed/:vendorId/:vendorName',
    name: 'AddPartnerFromGetListed',
    component: AddPartnerFromGetListed,
  },
  {
    path: '/agency/send-invitation',
    name: 'SendInvitation',
    component: SendInvitation,
  },
  {
    path: '/agency/our-directory',
    name: 'OurDirectory',
    component: OurDirectory,
  },
  {
    path: '/agency/our-directory/settings',
    name: 'Settings',
    component: Settings,
    children: [
      {
        path: '',
        component: SettingsForm,
      },
      {
        path: 'categories',
        components: {
          categories: SettingsCategories,
        },
      },
    ],
  },
  {
    path: '/agency/our-directory/manage-partners',
    name: 'ManagePartners',
    component: ManagePartners,
  },
  {
    path: '/agency/our-directory/manage-partners/:name',
    name: 'ManagePartnersDetail',
    component: ManagePartnersDetail,
  },
  {
    path: '/agency/our-directory/manage-partners/invitation/:id',
    name: 'ManagePartnersInvitation',
    component: ManagePartnersInvitation,
  },
  {
    path: '/account',
    name: 'account',
    component: UserAccount,
    children: [
      {
        path: '',
        component: UserAccountNameForm,
      },
      {
        path: 'name',
        component: UserAccountNameForm,
      },
      {
        path: 'password',
        components: {
          password: UserAccountPasswordForm,
        },
      },
      {
        path: 'api',
        components: {
          api: UserAccountApiForm,
        },
      },
    ],
  },
  {
    path: '/account/team',
    component: UserAccountTeamList,
  },
  {
    path: '/account/team/invite',
    component: UserAccountTeamInvite,
  },
  {
    path: '*',
    redirect: '/agency/our-public-profiles',
  },
];
